import { useStore } from "utils/useStore";
import AgentStore from "./AgentStore";

// Assumes agentStore has a chats object keyed by chatId
export function useCurrentChatStore() {
    const agentStore = useStore(AgentStore);

    return agentStore.currentChatStore;
}
